import "toastr/build/toastr.min.css";
import toastr from 'toastr';

toastr.options = {
    "preventDuplicates": true,
    "hideDuration": 400
};

/**
 * Funkcje pomocniczne
 */

export const getSiblings = element => {
    let siblings = [];
    let node = element.parentNode.firstChild;

    do {
        if (node.nodeType === 1) {
            siblings.push(node);
        }
    } while (node = node.nextElementSibling);

    return siblings;
};

export const getSibling = (element, sibling) => {
    const el = isElement(element) ? element : document.querySelector(element);
    if (el === null) return false;

    const node = el.parentNode.querySelector(sibling);

    return (node && node.nodeType === 1) ? node : false;
};

/**
 * Szuka najbliższego rodzica w strukturze DOM
 * @param element
 * @param className
 * @returns {*}
 */
export const getParent = (element, className) => {
    while ( !element.classList.contains(className) && (element = element.parentElement) );
    return element;
};

/**
 * Znajduje bezpośrednie dzieci od wskazanego node
 * @param parent
 * @param selector
 * @returns {T[]}
 */
export const getChildren = (parent, selector) => {
    return Array.prototype.filter.call(parent.children, (node) => {
        return node.matches(selector);
    });
};

export const createMessageBox = (status, text) => {
    let elementPattern = '<div class="msg {{class}} text-left"><div class="msg__content">{{text}}</div></div>';
    const elementClass = status ? 'msg--success' : 'msg--error';

    elementPattern = elementPattern.replace('{{class}}', elementClass);
    elementPattern = elementPattern.replace('{{text}}', text);

    return elementPattern;
};

export const createPopover = text => {
    let elementPattern = '<div class="popover popover--red">{{text}}</div>';

    elementPattern = elementPattern.replace('{{text}}', text);

    return elementPattern;
};

export const isElement = o => {
    return (
        typeof HTMLElement === "object" ? o instanceof HTMLElement : //DOM2
            o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName === "string"
    );
};

export const isNode = o => {
    return (
        typeof Node === "object" ? o instanceof Node :
            o && typeof o === "object" && typeof o.nodeType === "number" && typeof o.nodeName === "string"
    );
};

export const addLoader = (where, opts = {}) => {
    const container = isElement(where) ? where : document.querySelector(where);
    if (container === null) return false;

    const defaults = {
        fullscreen: false,
        text: null
    };
    Object.assign(defaults, opts);

    const template = `<div class="loader${defaults.fullscreen ? ' loader--full-screen' : ''}">
        <div class="spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
        
        ${defaults.text ? '<div class="loader__text">' + defaults.text + '</div>' : ''}
    </div>`;

    container.insertAdjacentHTML('afterbegin', template);
};

export const removeLoader = where => {
    const loader = getSibling(where, '.loader') || where.querySelector('.loader');
    if (loader) loader.parentNode.removeChild(loader);
};

export const addAlert = (where, type, message, onlyOne = false, placement = 'afterend') => {
    const template = `
        <div class="msg msg--${type} text-left"><div class="msg__content">${message}</div></div>
    `;
    const container = isElement(where) ? where : document.querySelector(where);

    if (onlyOne) {
        switch (placement) {
            case 'beforebegin':
                // TODO
                break;
            case 'afterbegin':
                if (getChildren(container, '.msg').length) return false;
                break;
            case 'beforeend':
                if (getChildren(container, '.msg').length) return false;
                break;
            case 'afterend':
                // TODO
                break;
        }
    }
    container.insertAdjacentHTML(placement, template);
};

export const getTranslation = translation => {
    return window.translations[translation] || '';
};

export const showMessage = (status, text, title = '', params = {}) => {
    if (text.length > 0) {
        params = {
            "closeButton": false,
            "debug": false,
            "newestOnTop": true,
            "progressBar": false,
            "positionClass": "toast-top-right",
            "preventDuplicates": true,
            "onclick": null,
            "showDuration": "300",
            "hideDuration": "1000",
            "timeOut": "2000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut",
            ...params
        };
        toastr[status](text, title, params);
    }
};

export const getDocumentHeight = () => {
    const body = document.body, html = document.documentElement;

    return Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );
};

/**
 * Pobiera wysokość okna przeglądarki
 * @returns {number}
 */
export const getWindowHeight = () => {
    return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
};

/**
 * Pobier szerokość okna przeglądarki
 * @returns {number}
 */
export const getWindowWidth = () => {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
};

/**
 * Pobiera wartość scrolla okna przeglądarki
 * @returns {number}
 */
export const getScroll = () => {
    return {
        x: window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
        y: window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    };
};

export const getStyleValue = (element, property) => {
    const elementComputedStyles = window.getComputedStyle(element);
    return element.style[property] || elementComputedStyles[property];
};

export const smoothScroll = (element, compensateForHeader = false) => {
    const el = isElement(element) ? element : document.querySelector(element);
    if (el) {
        const bbox = el.getBoundingClientRect();
        let top = bbox.top + (window.pageYOffset || document.documentElement.scrollTop);

        if (compensateForHeader) {
            const header = document.querySelector('.header');
            if (header) {
                top = top + ( (header.offsetHeight + 15) * -1 );
            }
        }

        window.scrollTo({
            top: top,
            behavior: "smooth",
        });
    }
};

export const preparePrice = p => {
    let price = p;
    if (typeof p === "string") {
        price = p.replace(',', '.');
    }

    return parseFloat(parseFloat(price).toFixed(2)) || 0;
};

export const debounce = (fn, delay = 500) => {
    let timer, args;

    function debounced() {
        args = Array.prototype.slice.call(arguments);

        window.clearTimeout(timer);
        timer = window.setTimeout(() => {
            fn.apply(null, args);
        }, delay);
    }

    return debounced;
};

export const debounced = debounce(cb => {
    if (typeof cb === "function") cb();
}, 500);

export const setCookie = (name, value, days) => {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
};

export const getCookie = name => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
};

export const eraseCookie = name => {
    document.cookie = name + '=; Max-Age=-99999999;';
};

export const confirmDialog = (e, cb) => {
    e.preventDefault();
    e.stopPropagation();
    const $this = $(e.currentTarget) || $(e.target);
    $this.fancyConfirm({
        title: $this.attr('data-title') || "Czy jesteś pewien?",
        message: $this.attr('data-message') || "Pamiętaj, że proces usuwania jest nieodwracalny",
        okButton: $this.attr('data-ok') || 'Tak, usuń',
        noButton: $this.attr('data-no') || 'Anuluj',
        okIcon: $this.attr('data-ok-icon') || 'trash',
        closeButton: $this.attr('data-close-button') || false,
        callback: function (value) {
            if (typeof cb === "function") {
                cb(value);
            }
        }
    });
};

export const createElementFromHTML = html => {
    const div = document.createElement('div');
    div.innerHTML = html.trim();

    return div.firstChild;
};

export const makeQueryStringData = data => {
    if (typeof data !== "object") return false;

    return Object.keys(data).map(key => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
    }).join('&');
};

let lastScrollTop = 0;
export const getScrollDirection = () => {
    const st = getScroll().y;
    let scrollDirection = '';
    if (st > lastScrollTop){
        scrollDirection = 'scrolldown';
    } else {
        scrollDirection = 'scrollup';
    }
    lastScrollTop = st <= 0 ? 0 : st;
    return scrollDirection;
};

window.showMessage = showMessage;



// WEBPACK FOOTER //
// ./src/assets/js/common/Utils.js